export const comments_3787345 = {"data":{"data":[],"links":{}}}